import type { Dispatch, FC, SetStateAction } from "react";

import { Stack } from "@mui/material";
import CustomTextField from "../../../CustomTextField";
import CustomDropdown from "../../../CustomDropdown";

import { useTranslation } from "react-i18next";
import { saleType } from "../../../../constants/notifications";

interface SettingsTabShoptetCouponCodeCaseProps {
  couponCode?: string;
  couponSale?: string;
  selectedSaleType?: string;
  couponSaleType?: string;
  setCouponCode?: Dispatch<SetStateAction<string>>;
  setCouponSale?: Dispatch<SetStateAction<string>>;
  setSelectedSaleType?: Dispatch<SetStateAction<string>>;
  setCouponSaleType?: Dispatch<SetStateAction<string>>;
}

export const SettingsTabShoptetCouponCodeCase: FC<
  SettingsTabShoptetCouponCodeCaseProps
> = ({
  couponCode,
  couponSale,
  selectedSaleType,
  couponSaleType,
  setCouponSaleType,
  setCouponSale,
  setCouponCode,
  setSelectedSaleType,
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction='column'
      sx={{
        pt: 1,
        gap: 1.5,
        py: 2,
      }}
    >
      <CustomTextField
        fullWidth
        label={t("campaign.notifications.shoptetCouponCode.code") ?? ""}
        value={couponCode ?? ""}
        onChange={e => {
          if (setCouponCode) {
            setCouponCode(e.target.value);
          }
        }}
      />
      <Stack
        direction='row'
        alignItems='center'
        spacing={2}
        justifyContent='space-between'
      >
        <CustomTextField
          fullWidth
          label={t("campaign.notifications.shoptetCouponCode.saleType") ?? ""}
          value={couponSale ?? ""}
          type='number'
          onChange={e => {
            if (setCouponSale) {
              setCouponSale(e.target.value);
            }
          }}
        />
        <CustomDropdown
          label={t("campaign.notifications.shoptetCouponCode.saleIn") ?? ""}
          items={saleType}
          width={150}
          onChange={event => {
            if (setSelectedSaleType) {
              setSelectedSaleType(event.target.value);
            }
          }}
          value={selectedSaleType}
        />
      </Stack>
      <CustomTextField
        fullWidth
        label={t("campaign.notifications.shoptetCouponCode.saleOn") ?? ""}
        value={couponSaleType ?? ""}
        onChange={e => {
          if (setCouponSaleType) {
            setCouponSaleType(e.target.value);
          }
        }}
        placeholder={
          t("campaign.notifications.shoptetCouponCode.wholeSale") ?? ""
        }
      />
    </Stack>
  );
};
